/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2015 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/

/*
	Finds the first scrolling element on the page and attaches events to it.
	There should only be one scrolling element in Start at a time.
	There can be multiple scrolling elements in FNFT.
*/
riot.mixin('scroll-end', {
	init: function() {
		this.scrollPane = null;
		this.scrollContainer = null;

		this.on('mount unmount', function(evt) {
			if (evt === 'mount') {
				this.scrollPane = document.querySelector('.scroll-pane');
				this.scrollContainer = document.querySelector('.scroll-container');

				if (this.scrollContainer && this.scrollPane) {
					this.scrollContainer.addEventListener('scroll', this.onScroll);
				}
			}
			else if (evt === 'unmount') {
				if (this.scrollContainer && this.scrollPane) {
					this.scrollContainer.removeEventListener('scroll', this.onScroll);
				}
			}
		});
	},

	onScroll: function(evt) {
		if (this.scrollPane.offsetHeight === this.scrollContainer.offsetHeight + this.scrollContainer.scrollTop) {
			this.trigger('scroll-end');
		}
	}
});
